import { Component, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-list-showcase',
  templateUrl: './list-showcase.component.html',
  styleUrls: ['./list-showcase.component.scss']
})
export class ListShowcaseComponent {
  @ViewChild('customItemTemplate') customItemTemplate!: TemplateRef<any>;

  // Text list items
  textItems = ['Apple', 'Banana', 'Cherry', 'Date', 'Elderberry'];

  // Checkbox list items
  checkboxItems = [
    { id: 1, name: 'Feature 1' },
    { id: 2, name: 'Feature 2' },
    { id: 3, name: 'Feature 3' },
    { id: 4, name: 'Feature 4' }
  ];

  // Radio button items
  radioItems = [
    { id: 'option1', name: 'Option 1' },
    { id: 'option2', name: 'Option 2' },
    { id: 'option3', name: 'Option 3' }
  ];

  // Custom items
  customItems = [
    { id: 1, title: 'Task 1', status: 'completed', priority: 'high' },
    { id: 2, title: 'Task 2', status: 'pending', priority: 'medium' },
    { id: 3, title: 'Task 3', status: 'in-progress', priority: 'low' }
  ];

  selectedTextItems: any[] = [];
  selectedCheckboxItems: any[] = [];
  selectedRadioItems: any[] = [];
  selectedCustomItems: any[] = [];

  onTextSelection(items: any[]): void {
    this.selectedTextItems = items || [];
  }

  onCheckboxSelection(items: any[]): void {
    this.selectedCheckboxItems = items || [];
  }

  onRadioSelection(items: any[]): void {
    this.selectedRadioItems = items || [];
  }

  onCustomSelection(items: any[]): void {
    this.selectedCustomItems = items || [];
  }

  getPriorityClass(priority: any): string {
    if (!priority || typeof priority !== 'string') return 'priority-low';
    const map: { [key: string]: string } = {
      'high': 'priority-high',
      'medium': 'priority-medium',
      'low': 'priority-low'
    };
    return map[priority] || 'priority-low';
  }

  getStatusClass(status: any): string {
    if (!status || typeof status !== 'string') return 'status-pending';
    const map: { [key: string]: string } = {
      'completed': 'status-completed',
      'pending': 'status-pending',
      'in-progress': 'status-in-progress'
    };
    return map[status] || 'status-pending';
  }

  getRadioSelectedLabel(): string {
    if (!this.selectedRadioItems || this.selectedRadioItems.length === 0) {
      return '';
    }
    const item = this.selectedRadioItems[0];
    if (!item) return '';
    return item.name || item.id || '';
  }
}
